const einProgram = {
  einProgram: {
    pageHeader: 'Leads en Enphase Installateursnetwerk',
    title: 'EIN-lidmaatschap aanvaard',
    overview: 'Overzicht',
    noCompany: 'Geen bedrijf gevonden',
    goToDashboard: 'Ga naar Dashboard',
    messageFromCeo: 'Lees het bericht van onze CEO',
    companyProfileLink: 'Update uw bedrijfsprofiel',
    serviceAreasLink: 'Selecteer uw servicegebieden',
    leadsPreferencesLink: 'Stel uw Leads Voorkeuren in',
    reviewInstallerLink: "Beoordeling installateur T&C's",
    open: 'open',
    video: 'video',
    selected: 'geselecteerde',
    learnMore: 'Meer informatie',
    completed: 'Voltooid',
    pending: 'Onvoltooid',
    optInDisabledHeader: 'EIN-programma (Binnenkort beschikbaar)',
    optInDisabledDescription:
      'Enphase Installer Network (EIN) is de perfecte manier voor huiseigenaren om u te vinden! Huiseigenaren vertrouwen op EIN om installateurs te identificeren die de hoogste normen van klantenservice en systeemkwaliteit leveren met behulp van Enphase producten. Als EIN-lid profiteert u van verschillende voordelen die u helpen meer te verkopen, meer te installeren en meer te verdienen.',
    einTier: 'Uw Enphase Installateursnetwerk (EIN) niveau: ',
    none: 'Geen',
    viewBenefits: 'Om uw EIN-voordelen te bekijken, klikt u op ',
    here: 'hier',
    anyQuestions: ' Als u vragen heeft over uw EIN-lidmaatschap, neem dan contact op met uw',
    enphaseAccountRepresentative: ' Enphase Account vertegenwoordiger.',
    learnReceivingLeads: 'Leer hoe u leads ontvangt van het digitale platform Enphase. ',
    benefitsOfEIN: 'Bekijk de voordelen van de EIN.',
    contactEnphaseRepresentative:
      'Neem contact op met uw Enphase Accountvertegenwoordiger voor meer informatie over EIN en het Enphase Leads Programma.',
    congratulations: 'Gefeliciteerd!',
    whichInstaller: '%{tierName} Installateur. ',
    invitationText1: 'U bent uitgenodigd om deel te nemen aan het Enphase Installer Network (EIN) als een ',
    invitationText2:
      'Het Enphase Installer Network (EIN) is ons vertrouwde netwerk van installateurs die een uitzonderlijke ervaring leveren aan huiseigenaren met behulp van Enphase producten. Het EIN is ontworpen om onze relatie met u te versterken en uw groei te versnellen. Als EIN-lid profiteert u van de verschillende voordelen die u helpen meer te verkopen, meer te installeren en meer te maken. Bekijk de volledige voordelen ',
    acceptInvitation: 'Om uw uitnodiging te accepteren:',
    acceptTerms: 'Ik accepteer de Algemene Voorwaarden',
    cellmodemCheck: 'Ik accepteer de',
    cellmodemTeamcondition: ' Algemene Voorwaarden ',
    cellmodemLinkTitle: 'van de Mobiele Connectie Gegevensuitbreiding',
    notEstablished: 'Niet vastgesteld.',
    contactEin: 'Neem contact op met uw Enphase Accountvertegenwoordiger voor meer informatie over EIN.',
    getFreeLeads: 'Vul de onderstaande stappen in om gratis leads te krijgen:'
  }
};

export default einProgram;
